// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"styles_loadingIndicator__eaSMR"};